module.exports = __webpack_public_path__ + "static/img/loginImage.5432081.png";